document.addEventListener("DOMContentLoaded", function () {

    /*=========================================
      FILTER DROPDOWN
    =========================================*/

    /*=========================================
  FILTER DROPDOWN
=========================================*/

const dropdowns = document.querySelectorAll(".filter-dropdown");

// Hide all dropdowns on page load
dropdowns.forEach((dropdown) => {

    const panel = dropdown.querySelector(".filter-dropdown__panel");
    const toggle = dropdown.querySelector(".filter-dropdown__toggle");

    if (!panel || !toggle) return;

    dropdown.classList.remove("active");

    panel.setAttribute("hidden", "");

    toggle.setAttribute("aria-expanded", "false");

});

// Dropdown Click
dropdowns.forEach((dropdown) => {

    const toggle = dropdown.querySelector(".filter-dropdown__toggle");
    const panel = dropdown.querySelector(".filter-dropdown__panel");

    if (!toggle || !panel) return;

    toggle.addEventListener("click", function (e) {

        e.preventDefault();

        e.stopPropagation();

        const isAlreadyOpen = dropdown.classList.contains("active");

        // Close all dropdowns first
        dropdowns.forEach((item) => {

            item.classList.remove("active");

            const p = item.querySelector(".filter-dropdown__panel");
            const t = item.querySelector(".filter-dropdown__toggle");

            if (p) {

                p.setAttribute("hidden", "");

            }

            if (t) {

                t.setAttribute("aria-expanded", "false");

            }

        });

        // Open current dropdown only if it wasn't already open
        if (!isAlreadyOpen) {

            dropdown.classList.add("active");

            panel.removeAttribute("hidden");

            toggle.setAttribute("aria-expanded", "true");

        }

    });

});

// Close when clicking outside
document.addEventListener("click", function () {

    dropdowns.forEach((dropdown) => {

        dropdown.classList.remove("active");

        const panel = dropdown.querySelector(".filter-dropdown__panel");
        const toggle = dropdown.querySelector(".filter-dropdown__toggle");

        if (panel) {

            panel.setAttribute("hidden", "");

        }

        if (toggle) {

            toggle.setAttribute("aria-expanded", "false");

        }

    });

});

// Prevent closing when clicking inside dropdown panel
document.querySelectorAll(".filter-dropdown__panel").forEach((panel) => {

    panel.addEventListener("click", function (e) {

        e.stopPropagation();

    });

});



    /*=========================================
      CLOSE FILTER ON OUTSIDE CLICK
    =========================================*/

    document.addEventListener("click", function () {

        document.querySelectorAll(".filter-dropdown").forEach((dropdown) => {

            dropdown.classList.remove("active");

            const panel = dropdown.querySelector(".filter-dropdown__panel");

            const toggle = dropdown.querySelector(".filter-dropdown__toggle");

            if (panel) panel.hidden = true;

            if (toggle) toggle.setAttribute("aria-expanded", "false");

        });

    });



    /*=========================================
      SORT PRODUCTS
    =========================================*/

    const sortSelect = document.getElementById("SortBy");

    if (sortSelect) {

        sortSelect.addEventListener("change", function () {

            const url = new URL(window.location.href);

            url.searchParams.set("sort_by", this.value);

            window.location.href = url.toString();

        });

    }



    /*=========================================
      FILTER CHECKBOXES
    =========================================*/

    document.querySelectorAll(".filter-option input").forEach((checkbox) => {

        checkbox.addEventListener("change", function () {

            applyFilters();

        });

    });



    /*=========================================
      PRICE FILTER
    =========================================*/

    const applyBtn = document.querySelector(".filter-apply-btn");

    if (applyBtn) {

        applyBtn.addEventListener("click", function () {

            applyFilters();

        });

    }



    function applyFilters() {

    const url = new URL(window.location.href);

    // Remove only previous filter params
    [...url.searchParams.keys()].forEach((key) => {

        if (key.startsWith("filter.")) {

            url.searchParams.delete(key);

        }

    });

    // ==========================
    // Checkbox Filters
    // ==========================

    document.querySelectorAll(".filter-option input:checked").forEach((checkbox) => {

        const [key, value] = checkbox.value.split("=");

        if (key && value) {

            url.searchParams.append(key, value);

        }

    });

    // ==========================
    // Price Filter
    // ==========================

    const min = document.querySelector("[data-type='min']");
    const max = document.querySelector("[data-type='max']");

    if (min && min.value.trim() !== "") {

        url.searchParams.set(min.name, min.value.trim());

    }

    if (max && max.value.trim() !== "") {

        url.searchParams.set(max.name, max.value.trim());

    }

    // ==========================
    // Sort
    // ==========================

    const sort = document.getElementById("SortBy");

    if (sort && sort.value) {

        url.searchParams.set("sort_by", sort.value);

    }

    window.location.href = url.toString();

}

});

/*=========================================
  ADD TO CART (AJAX)
=========================================*/

document.querySelectorAll(".add-cart-btn").forEach((button) => {

    button.addEventListener("click", function (e) {

        e.preventDefault();

        const form = this.closest(".collection-cart-form");

        if (!form) return;

        const variantId = form.querySelector("input[name='id']").value;

        const quantityInput = form.querySelector("input[name='quantity']");
        const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

        button.disabled = true;
        button.innerHTML = "Adding...";

        fetch("/cart/add.js", {

            method: "POST",

            headers: {
                "Content-Type": "application/json"
            },

            body: JSON.stringify({

                id: variantId,

                quantity: quantity

            })

        })

        .then(response => {

            if (!response.ok) {

                throw new Error("Unable to add product");

            }

            return response.json();

        })

        .then(() => {

            button.innerHTML = "Added ✓";

            /* Refresh cart count */

            fetch("/cart.js")

            .then(res => res.json())

            .then(cart => {

                document.querySelectorAll(".cart-count").forEach((count)=>{

                    count.innerHTML = cart.item_count;

                });

            });

            setTimeout(() => {

                button.innerHTML = "Add to Cart";

                button.disabled = false;

            },1500);

        })

        .catch(() => {

            button.innerHTML = "Try Again";

            button.disabled = false;

        });

    });

});



/*=========================================
  BUY NOW
=========================================*/

document.querySelectorAll(".buy-now-btn").forEach((button)=>{

    button.addEventListener("click",function(){

        const variantId = this.dataset.variant;

        if(!variantId) return;

        this.disabled = true;

        this.innerHTML = "Redirecting...";

        fetch("/cart/clear.js",{

            method:"POST"

        })

        .then(()=>{

            return fetch("/cart/add.js",{

                method:"POST",

                headers:{
                    "Content-Type":"application/json"
                },

                body:JSON.stringify({

                    id:variantId,

                    quantity:1

                })

            });

        })

        .then(()=>{

            window.location="/checkout";

        });

    });

});



/*=========================================
  QUANTITY BUTTONS
=========================================*/

document.querySelectorAll(".qty-selector").forEach((wrapper) => {

    const minus = wrapper.querySelector(".qty-btn--minus");

    const plus = wrapper.querySelector(".qty-btn--plus");

    const input = wrapper.querySelector(".qty-input");

    if (!input) return;


    /*=========================================
      UPDATE BUTTON STATE
    =========================================*/

    function updateQuantityButtons() {

        let value = parseInt(input.value, 10);

        if (isNaN(value) || value < 1) {

            value = 1;

            input.value = value;

        }


        /* Disable minus at 1 */

        if (minus) {

            minus.disabled = value <= 1;

        }


        /* Check maximum quantity if available */

        const max = parseInt(
            input.getAttribute("max"),
            10
        );

        if (plus) {

            if (!isNaN(max)) {

                plus.disabled = value >= max;

            } else {

                plus.disabled = false;

            }

        }

    }


    /*=========================================
      MINUS BUTTON
    =========================================*/

    if (minus) {

        minus.addEventListener("click", function () {

            let value = parseInt(input.value, 10) || 1;

            if (value > 1) {

                value--;

                input.value = value;

            }

            updateQuantityButtons();

        });

    }


    /*=========================================
      PLUS BUTTON
    =========================================*/

    if (plus) {

        plus.addEventListener("click", function () {

            let value = parseInt(input.value, 10) || 1;

            const max = parseInt(
                input.getAttribute("max"),
                10
            );


            if (!isNaN(max) && value >= max) {

                return;

            }


            value++;

            input.value = value;

            updateQuantityButtons();

        });

    }


    /*=========================================
      MANUAL INPUT
    =========================================*/

    input.addEventListener("input", function () {

        updateQuantityButtons();

    });


    input.addEventListener("change", function () {

        let value = parseInt(input.value, 10);

        if (isNaN(value) || value < 1) {

            value = 1;

        }

        input.value = value;

        updateQuantityButtons();

    });


    /*=========================================
      INITIAL STATE
    =========================================*/

    updateQuantityButtons();

});


/*=========================================
  FAQ ACCORDION
=========================================*/

// document.addEventListener("DOMContentLoaded", function () {

//     const faqItems = document.querySelectorAll(".faq-item");

//     if (!faqItems.length) return;

//     faqItems.forEach((item) => {

//         const header = item.querySelector(".faq-item__header");
//         const body = item.querySelector(".faq-item__body");

//         if (!header || !body) return;

//         // Open first FAQ
//         if (item.classList.contains("active")) {
//             body.style.maxHeight = body.scrollHeight + "px";
//         }

//         header.addEventListener("click", function () {

//             const isOpen = item.classList.contains("active");

//             // Close all FAQs
//             faqItems.forEach((faq) => {

//                 faq.classList.remove("active");

//                 const faqBody = faq.querySelector(".faq-item__body");

//                 if (faqBody) {
//                     faqBody.style.maxHeight = null;
//                 }

//             });

//             // Open clicked FAQ
//             if (!isOpen) {

//                 item.classList.add("active");

//                 body.style.maxHeight = body.scrollHeight + "px";

//             }

//         });

//     });

// });


/*=========================================
  PRODUCT IMAGE HOVER
=========================================*/

document.querySelectorAll(".product-card").forEach((card) => {

    const images = card.querySelectorAll("img");

    if (images.length < 2) return;

    const mainImage = images[0];
    const hoverImage = images[1];

    hoverImage.style.opacity = "0";
    hoverImage.style.transition = "opacity .35s ease";
    mainImage.style.transition = "opacity .35s ease";

    card.addEventListener("mouseenter", function () {

        mainImage.style.opacity = "0";
        hoverImage.style.opacity = "1";

    });

    card.addEventListener("mouseleave", function () {

        mainImage.style.opacity = "1";
        hoverImage.style.opacity = "0";

    });

});


/*=========================================
  CART COUNT REFRESH
=========================================*/

function updateCartCount() {

    fetch("/cart.js")

    .then(response => response.json())

    .then(cart => {

        document.querySelectorAll(".cart-count").forEach((badge) => {

            badge.textContent = cart.item_count;

        });

    })

    .catch(() => {});

}

updateCartCount();


/*=========================================
  SCROLL TO TOP ON SORT
=========================================*/

const sortDropdown = document.getElementById("SortBy");

if (sortDropdown) {

    sortDropdown.addEventListener("change", function () {

        window.scrollTo({

            top: 0,

            behavior: "smooth"

        });

    });

}


/*=========================================
  PRODUCT IMAGE FADE-IN
=========================================*/

document.querySelectorAll(".product-card img").forEach((img) => {

    if (img.complete) {

        img.classList.add("loaded");

    } else {

        img.addEventListener("load", function () {

            img.classList.add("loaded");

        });

    }

});


/*=========================================
  ACTIVE FILTER COUNT
=========================================*/

const activeFilters = document.querySelectorAll(".filter-option input:checked");

const filterLabel = document.querySelector(".toolbar-label");

if (filterLabel && activeFilters.length > 0) {

    filterLabel.innerHTML = `Filter By (${activeFilters.length})`;

}


/*=========================================
  STICKY TOOLBAR
=========================================*/

const toolbar = document.querySelector(".product-listing__toolbar");

if (toolbar) {

    const stickyTop = toolbar.offsetTop;

    window.addEventListener("scroll", function () {

        if (window.scrollY > stickyTop) {

            toolbar.classList.add("is-sticky");

        } else {

            toolbar.classList.remove("is-sticky");

        }

    });

}


/*=========================================
  ESC CLOSE FILTERS
=========================================*/

document.addEventListener("keydown", function (e) {

    if (e.key !== "Escape") return;

    document.querySelectorAll(".filter-dropdown").forEach((dropdown) => {

        dropdown.classList.remove("active");

        const panel = dropdown.querySelector(".filter-dropdown__panel");

        if (panel) {

            panel.hidden = true;

        }

    });

});


/*=========================================
  END
=========================================*/


